<template>
  <div class="home">
    <component :is="currentCmp"></component>
  </div>
</template>

<script setup>
import Mobile from "./Mobile.vue";
import Computer from "./Computer.vue";
import { onMounted, ref } from "vue";
const currentCmp = ref("");
onMounted(() => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  currentCmp.value =
    /android|iPhone|iPad|iPod|blackberry|iemobile|opera mini/i.test(userAgent)
      ? Mobile
      : Computer;
});
</script>

<style lang="scss">
.home {
  color: #f35d8d;
  background: radial-gradient(0% 0% at 0% 0%, #fcf3f4 0%, #f9f7fb 100%);
}
</style>
